import { CardWidget } from 'admin-lte'

const SELECTOR_DATA_COLLAPSE = '[data-lte-toggle="card-collapse"]'

/**
 * Registers the AdminLTE CardWidget Unpoly compiler.
 */
export function registerCardWidgetCompiler() {
  up.compiler(SELECTOR_DATA_COLLAPSE, function (element, data) {
    const cardWidget = new CardWidget(element, {
      animationSpeed: 500,
      collapseTrigger: SELECTOR_DATA_COLLAPSE
    })
    if (data.collapseOnLoad) {
      cardWidget.collapse()
    }
  })
}

export default registerCardWidgetCompiler
